import qs from 'qs'

import useAxios from '@/utilities/useAxios'

const DND_SERVICE = `${import.meta.env.VITE_DND_APP_BACKEND_URL}`
// interface SearchParams {
//   keyword?: string
//   startCreatedDate?: string
//   endCreatedDate?: string
//   startModifiedDate?: string
//   endModifiedDate?: string
//   startDate?: string
//   endDate?: string
//   page: number
//   size: number
//   sort: string | string[]
//   pageable?: object
// }

interface SearchAreaControllerProps {
  keyword: string
  startCreatedDate: string
  endCreatedDate: string
  startModifiedDate: string
  endModifiedDate: string
  page: number
  size: number
  sort: string
  order: string
  pageable: object
  roleName?: string
}

interface SearchProvincesProps {
  keyword: string
  startCreatedDate: string
  endCreatedDate: string
  startModifiedDate: string
  endModifiedDate: string
  page: number
  size: number
  sort: string
  pageable: object
}

interface SearchBranchesProps {
  page: number
  size: number
  sort: string
  order: string
  isMapped: boolean
}

interface SearchAreaProps {
  keyword?: string
  sinceCreated?: string
  untilCreated?: string
  sinceModified?: string
  untilModified?: string
  page: number
  size: number
  sort: string
  pageable?: object
}

interface SearchSupervisorProps {
  keyword: string
  startCreatedDate: string
  endCreatedDate: string
  startModifiedDate: string
  endModifiedDate: string
  page: number
  size: number
  sort: string
  pageable: object
}

// interface BaseResponse<T> {
//   httpStatus: string
//   success: boolean
//   message: string
//   data: T[] | null
//   errors: null | any
//   errorCode: number
//   timestamp: number
//   path: null | string
//   totalElements: number | null
//   size: number
// }

export interface SyncProvincesRequest {
  Id: number
  sourceAreaIds: number[]
}

export interface SyncAreaRequest {
  Id: number
  sourceAreaIds: number[]
}

interface AssignSupervisorRequest {
  userID: number
  userAreaControllerIds: number[]
}

interface AssignAreaControllerRequest {
  userID: number
  areaIds: number[]
}

interface AssignProvinceRequest {
  areaID: number | string
  sourceAreaId: number
  sourceProvinceIds: number[]
}

interface CreateAreaProps {
  name: string
  code: string
  sourceBranchIds: number[]
}

export const createArea = async (data: CreateAreaProps) => {
  return await useAxios.post(`${DND_SERVICE}/v2/area`, data)
}

export const searchAllAreaControllers = async (
  params: SearchAreaControllerProps,
) => {
  try {
    const response = await useAxios.get(`${DND_SERVICE}/v2/user-area/search`, {
      params,
    })
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const searchAllBranches = async (params: SearchBranchesProps) => {
  try {
    const response = await useAxios.get(`${DND_SERVICE}/v2/branch/search`, {
      params,
    })
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const searchAllProvinces = async (params: SearchProvincesProps) => {
  try {
    const response = await useAxios.get(`${DND_SERVICE}/v1/province/search`, {
      params,
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: 'repeat' }),
    })
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const searchAllAreas = async ({
  keyword,
  sinceCreated,
  untilCreated,
  sinceModified,
  untilModified,
  page,
  size,
  sort,
}: SearchAreaProps) => {
  try {
    const response = await useAxios.get(`${DND_SERVICE}/v2/area/search`, {
      params: {
        keyword: keyword,
        sinceCreated,
        untilCreated,
        sinceModified,
        untilModified,
        page: page,
        size: size,
        sort: sort.split(',')[0],
        order: sort.split(',')[1].length > 0 || 'desc',
      },
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: 'repeat' }),
    })

    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const searchAllSupervisors = async (params: SearchSupervisorProps) => {
  try {
    const response = await useAxios.get(
      `${DND_SERVICE}/v1/area-supervisor/search`,
      {
        params,
        paramsSerializer: (params) =>
          qs.stringify(params, { arrayFormat: 'repeat' }),
      },
    )
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const syncProvinces = async (data?: SyncProvincesRequest) => {
  try {
    const response = await useAxios.post(
      `${DND_SERVICE}/v1/sync/province`,
      data != null || {},
    )
    return response
  } catch (error) {
    console.error('Error syncing area:', error)
    throw error
  }
}

export const syncArea = async (data?: SyncAreaRequest) => {
  try {
    const response = await useAxios.post(
      `${DND_SERVICE}/v1/sync/area`,
      data != null || {},

    )
    return response
  } catch (error) {
    console.error('Error syncing area:', error)
    throw error
  }
}

export const assignProvince = async (data: AssignProvinceRequest) => {
  const areaId = data.areaID
  try {
    const response = await useAxios.put(
      `${DND_SERVICE}/v2/area/${areaId}`, data )
    return response
  } catch (error) {
    console.error('Error assigning supervisor:', error)
    throw error
  }
}

export const assignBranches = async (data: AssignProvinceRequest) => {
  try {
    const response = await useAxios.put(`${DND_SERVICE}/v2/area`, data, )
    return response
  } catch (error) {
    console.error('Error assigning supervisor:', error)
    throw error
  }
}

export const assignSupervisor = async (data: AssignSupervisorRequest) => {
  try {
    const response = await useAxios.put(
      `${DND_SERVICE}/v1/area-supervisor/assign-area-supervisor`,
      data,)
    return response
  } catch (error) {
    console.error('Error assigning supervisor:', error)
    throw error
  }
}

export const assignAreaController = async (
  data: AssignAreaControllerRequest,
) => {
  try {
    const response = await useAxios.put(`${DND_SERVICE}/v2/user-area`, data )
    return response
  } catch (error) {
    console.error('Error assigning area controller:', error)
    throw error
  }
}

export const getAreaDetails = async (areaId: number) => {
  try {
    const response = await useAxios.get(`${DND_SERVICE}/v1/area/${areaId}`, )
    return response
  } catch (error) {
    console.error('Error getting area details:', error)
    throw error
  }
}

export const getAreaSupervisors = async (areaId: number) => {
  try {
    const response = await useAxios.get(
      `${DND_SERVICE}/v1/area-supervisor/${areaId}`,
    )
    return response
  } catch (error) {
    console.error('Error getting area supervisors:', error)
    throw error
  }
}

export const getAreaControllers = async (areaId: number) => {
  try {
    const response = await useAxios.get(
      `${DND_SERVICE}/v1/area-controller/${areaId}`,)
    return response
  } catch (error) {
    console.error('Error getting area controllers:', error)
    throw error
  }
}
